import { Tower } from './Tower';
import { Monster } from '../monsters/Monster';

export class FreezeTower extends Tower {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    // damage: 20, attackSpeed: 1.0, range: 140 - slows and freezes enemies
    super(scene, x, y, 20, 1.0, 140);
    
    this.removeAll();
    this.createFreezeVisuals();
  }

  protected override createVisuals(): void {
    // Create freeze tower base
    const base = this.scene.add.circle(0, 0, 20, 0x0066cc);
    this.add(base);
    
    // Create ice crystal cannon
    const crystal = this.scene.add.polygon(0, -15, [
      [0, -15], [8, 0], [0, 15], [-8, 0]
    ], 0x66ccff);
    this.add(crystal);
    
    // Add frost effect
    const frost = this.scene.add.circle(0, 0, 15, 0x99ddff, 0.3);
    this.add(frost);
  }

  private createFreezeVisuals(): void {
    this.createVisuals();
  }

  protected override fireProjectile(target: Monster, damage: number, isCrit: boolean): void {
    // Create ice projectile
    const iceProjectile = this.scene.add.circle(this.x, this.y, isCrit ? 6 : 4, isCrit ? 0x0044ff : 0x66ccff);
    
    this.scene.tweens.add({
      targets: iceProjectile,
      x: target.x,
      y: target.y,
      duration: 200,
      ease: 'Power2',
      onComplete: () => {
        // Apply damage
        target.takeDamage(damage);
        
        // Apply freeze effect
        this.applyFreezeEffect(target, isCrit);
        
        if (isCrit) {
          this.showCritEffect(target.x, target.y);
        }
        
        iceProjectile.destroy();
      }
    });
  }

  private applyFreezeEffect(target: Monster, isCrit: boolean): void {
    // Create ice overlay on monster
    const iceOverlay = this.scene.add.circle(target.x, target.y, 15, 0x66ccff, 0.5);
    
    // Slow down monster (if it has speed property)
    if ('speed' in target) {
      const originalSpeed = (target as any).speed;
      (target as any).speed = originalSpeed * (isCrit ? 0.2 : 0.5); // Slow to 20% or 50%
      
      // Restore speed after freeze duration
      this.scene.time.delayedCall(isCrit ? 3000 : 2000, () => {
        if (target && target.active) {
          (target as any).speed = originalSpeed;
        }
      });
    }
    
    // Remove ice overlay
    this.scene.time.delayedCall(isCrit ? 3000 : 2000, () => {
      iceOverlay.destroy();
    });
    
    // Area freeze effect for crits
    if (isCrit) {
      this.applyAreaFreeze(target.x, target.y);
    }
  }

  private applyAreaFreeze(x: number, y: number): void {
    const freezeRadius = 60;
    
    // Visual area effect
    const areaEffect = this.scene.add.circle(x, y, freezeRadius, 0x66ccff, 0.3);
    
    this.scene.tweens.add({
      targets: areaEffect,
      scaleX: 1.5,
      scaleY: 1.5,
      alpha: 0,
      duration: 1000,
      ease: 'Power2',
      onComplete: () => {
        areaEffect.destroy();
      }
    });
    
    // Apply freeze to nearby monsters
    if (this.scene && this.scene.children) {
      this.scene.children.list.forEach((child) => {
        if (child instanceof Monster && child.getIsActive()) {
          const distance = Phaser.Math.Distance.Between(x, y, child.x, child.y);
          if (distance <= freezeRadius) {
            this.applyFreezeEffect(child, false);
          }
        }
      });
    }
  }
} 